











import { Component, Vue } from "vue-property-decorator";
import { ConfigModule } from "@/store/index";

@Component({})
export default class Footer extends Vue {
  /* -------------- watch ------------- */

  /* -------------- computed ------------- */
  get lang () {
    // 已选语言key
    return ConfigModule.lang;
  }

  get categoryForUserTermTitle () {
    // 用户条款标题
    return ConfigModule.categoryForUserTermTitle;
  }

  get categoryForPrivacyTermTitle () {
    // 隐私策略标题
    return ConfigModule.categoryForPrivacyTermTitle;
  }

  get categoryForAgreementTitle () {
    // 公司名
    return ConfigModule.categoryForAgreementTitle;
  }

  get categoryForContactEmailTitle () {
    // 联系邮箱标题
    return ConfigModule.categoryForContactEmailTitle;
  }

  get categoryForContactEmailContent () {
    // 联系邮箱地址
    return ConfigModule.categoryForContactEmailContent;
  }

  /* -------------- hook ------------- */

  /* -------------- methods ------------- */
  clickMailTo () {
    ConfigModule.setIgnoreOnbeforeunload(true);
  }
}
